
import { Component, Vue } from "vue-property-decorator";
import LsDialog from "@/components/ls-dialog.vue";
import LsPagination from "@/components/ls-pagination.vue";
import ExportData from "@/components/export-data/index.vue";
import { apiWorkorderEnum } from "@/api/workorder";
import { RequestPaging, processInput } from "@/utils/util";

@Component({
  components: {
    LsDialog,
    LsPagination,
    ExportData,
  },
})
export default class WorkorderTypes extends Vue {
  /** S Data **/

  // 分页
  pager: RequestPaging = new RequestPaging();
  processInput = processInput;

  /** E Data **/

  /** S Methods **/

  // 获取资讯文章列表
  getList() {
    this.pager
      .request({
        callback: apiWorkorderEnum,
        params: {},
      })
      .catch((err: any) => {
        console.log("err", err);
      });
  }

  /** E Methods **/

  /** S Life Cycle **/
  created() {
    this.getList();
  }

  /** E Life Cycle **/
}
